import React from 'react';
import { Card, Text, Table, Skeleton } from '@mantine/core';
import { getStandings } from '../../../services/FootballService';

export default function StandingsPanel({ rapidKey, leagueId, season }) {
    const [rows, setRows] = React.useState(null);
    React.useEffect(() => {
        let stop = false;
        if (!leagueId || !season) return;
        (async () => {
            const resp = await getStandings({ key: rapidKey, params: { league: leagueId, season } });
            const table = resp?.[0]?.league?.standings?.[0] || [];
            if (!stop) setRows(table);
        })();
        return () => { stop = true; };
    }, [rapidKey, leagueId, season]);

    return (
        <Card withBorder radius="md" p="md" mt="lg">
            <Text fw={700} mb="xs">Table standings</Text>
            {!rows ? (
                <Skeleton h={220} radius="md" />
            ) : (
                <div style={{ overflowX: "auto" }}>
                    <Table
                        striped
                        highlightOnHover
                        withTableBorder
                        withColumnBorders
                        style={{ minWidth: "500px", whiteSpace: "nowrap" }} // 👈 force no-wrap
                    >
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th style={{ width: 20, fontSize: 12, textAlign: 'center', fontWeight: 'bold' }}>#</Table.Th>
                                <Table.Th style={{ width: 80, fontSize: 12, textAlign: 'left', fontWeight: 'bold' }}>Team</Table.Th>
                                <Table.Th style={{ width: 30, fontSize: 12, textAlign: 'center', fontWeight: 'bold' }}>MP</Table.Th>
                                <Table.Th style={{ width: 30, fontSize: 12, textAlign: 'center', fontWeight: 'bold' }}>W</Table.Th>
                                <Table.Th style={{ width: 30, fontSize: 12, textAlign: 'center', fontWeight: 'bold' }}>D</Table.Th>
                                <Table.Th style={{ width: 30, fontSize: 12, textAlign: 'center', fontWeight: 'bold' }}>L</Table.Th>
                                <Table.Th style={{ width: 30, fontSize: 12, textAlign: 'center', fontWeight: 'bold' }}>GD</Table.Th>
                                <Table.Th style={{ width: 30, fontSize: 12, textAlign: 'center', fontWeight: 'bold' }}>Pts</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {rows.map((r) => (
                                <Table.Tr key={r.team.id}>
                                    <Table.Td style={{ textAlign: 'center', fontSize: 12 }}>{r.rank}</Table.Td>
                                    <Table.Td>
                                        {/* <img
                                            src={CDN_TEAM_LOGO(r.team.id)}
                                            alt=""
                                            width={17}
                                            height={17}
                                            style={{ verticalAlign: 'middle', marginRight: 6 }}
                                        /> */}
                                        <span style={{ fontSize: 12, verticalAlign: 'middle' }}>{r.team.name}</span>
                                    </Table.Td>
                                    <Table.Td style={{ textAlign: 'center', fontSize: 12 }}>{r.all.played}</Table.Td>
                                    <Table.Td style={{ textAlign: 'center', fontSize: 12 }}>{r.all.win}</Table.Td>
                                    <Table.Td style={{ textAlign: 'center', fontSize: 12 }}>{r.all.draw}</Table.Td>
                                    <Table.Td style={{ textAlign: 'center', fontSize: 12 }}>{r.all.lose}</Table.Td>
                                    <Table.Td style={{ textAlign: 'center', fontSize: 12 }}>{r.goalsDiff}</Table.Td>
                                    <Table.Td style={{ textAlign: 'center', fontSize: 12 }}>
                                        <span style={{ fontWeight: 'bold' }}>{r.points}</span>
                                    </Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                </div>
            )}
        </Card>
    );
}
